export const getDatadogUser = (user, retailer) => {
    return {
        id: user.id,
        name: `Employee at ${retailer.domain_prefix}`,
        accountType: user.account_type,
        retailerId: retailer.id,
        retailerDomain: retailer.domain_prefix,
        accountStatus: retailer.account_status,
        language: navigator.language,
    };
};
